/**
 * mockERP — ERPPort adapter with plausible catalog + invoicing in memory.
 * V0.01 default. Demonstrates the shape without any real backend.
 */
export function createMockERP() {
  const CATALOG = [
    { id: "p1", sku: "SW-BASE", name: "Licencia base anual", kind: "subscription", listPrice: { amount: 2400, currency: "USD" }, tags: ["core"] },
    { id: "p2", sku: "SW-PRO",  name: "Licencia Pro anual",  kind: "subscription", listPrice: { amount: 4800, currency: "USD" }, tags: ["upsell"] },
    { id: "p3", sku: "SVC-IMPL", name: "Servicio de implementación", kind: "service", listPrice: { amount: 3500, currency: "USD" }, tags: ["cross_sell"] },
    { id: "p4", sku: "TR-01", name: "Capacitación 8h", kind: "service", listPrice: { amount: 900, currency: "USD" }, tags: ["cross_sell"] },
  ];
  const quotes = [];
  const orders = [];
  return {
    async status() { return { status: "connected", vendor: "mock" }; },
    async listInvoicesForActor() { return []; },
    async listCatalog() { return CATALOG.slice(); },
    async createQuote({ actorExternalId, items, notes }) {
      const quoteId = `q-${Date.now().toString(36)}`;
      quotes.push({ quoteId, actorExternalId, items, notes });
      return { quoteId, url: `https://erp.example.com/quotes/${quoteId}` };
    },
    async createOrder({ actorExternalId, items }) {
      const orderId = `o-${Date.now().toString(36)}`;
      orders.push({ orderId, actorExternalId, items });
      return { orderId };
    },
  };
}
